import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "vt_admin_token";
export const REFRESH_KEY = "vt_admin_refresh";
export const USER_KEY = "vt_admin_user";

export const adminHttp = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 30000,
});

adminHttp.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let refreshingPromise = null;

adminHttp.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const isAuthRoute = original?.url?.includes("/auth/");
    if (status === 401 && !original._retry && !isAuthRoute) {
      original._retry = true;
      const refresh = localStorage.getItem(REFRESH_KEY);
      if (!refresh) {
        clearAuth();
        redirectLogin();
        return Promise.reject(error);
      }
      try {
        if (!refreshingPromise) {
          refreshingPromise = axios
            .post(`${API}/auth/refresh`, { refresh_token: refresh })
            .finally(() => { refreshingPromise = null; });
        }
        const { data } = await refreshingPromise;
        localStorage.setItem(TOKEN_KEY, data.access_token);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return adminHttp(original);
      } catch (_) {
        clearAuth();
        redirectLogin();
      }
    }
    return Promise.reject(error);
  }
);

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
}

export function redirectLogin() {
  if (typeof window !== "undefined" && !window.location.pathname.startsWith("/admin/login")) {
    window.location.href = "/admin/login";
  }
}

export function formatApiError(err, fallback = "Ocurrió un error. Intenta de nuevo.") {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" · ");
  if (d && typeof d.msg === "string") return d.msg;
  return fallback;
}

export const STATUS_LABELS = {
  new: "Nuevo",
  contacted: "Contactado",
  qualified: "Calificado",
  quoted: "Cotizado",
  negotiation: "Negociación",
  won: "Ganado",
  lost: "Perdido",
};

export const STATUS_ORDER = ["new", "contacted", "qualified", "quoted", "negotiation", "won", "lost"];

export const STATUS_COLORS = {
  new: "#8cb62c",
  contacted: "#3B82F6",
  qualified: "#8B5CF6",
  quoted: "#EAB308",
  negotiation: "#06B6D4",
  won: "#22C55E",
  lost: "#64748B",
};

export const LOST_REASON_LABELS = {
  precio: "Precio",
  timing: "Timing",
  "no respondió": "No respondió",
  "eligió competencia": "Eligió competencia",
  "no califica": "No califica",
  otro: "Otro",
};

export function scoreColor(score) {
  if (score <= 30) return "#EF4444";
  if (score <= 60) return "#EAB308";
  return "#22C55E";
}
